import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from '../../../api/Constants';
import { skipEventError } from '../../api/services/utils/validations';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
import { getAssetsPackage } from '../assetsPackage';
export var getFriendsInviteQuery = {
  query: function query() {
    return {
      url: Endpoints.FRIENDS_INVITE
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
      var _ref$requestAssetsDat, requestAssetsData, dispatch, queryFulfilled, _data$friendsInviteFe, _data$friendsInviteFe2, _yield$queryFulfilled, data, _error$error, _error$error$data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref$requestAssetsDat = _ref.requestAssetsData, requestAssetsData = _ref$requestAssetsDat === void 0 ? null : _ref$requestAssetsDat;
              dispatch = _ref2.dispatch, queryFulfilled = _ref2.queryFulfilled;
              _context.prev = 2;
              _context.next = 5;
              return queryFulfilled;

            case 5:
              _yield$queryFulfilled = _context.sent;
              data = _yield$queryFulfilled.data;

              if (!requestAssetsData) {
                _context.next = 10;
                break;
              }

              _context.next = 10;
              return dispatch(getAssetsPackage.initiate({
                assetsPackageId: data === null || data === void 0 ? void 0 : (_data$friendsInviteFe = data.friendsInviteFeatureState) === null || _data$friendsInviteFe === void 0 ? void 0 : (_data$friendsInviteFe2 = _data$friendsInviteFe.inviteSetup) === null || _data$friendsInviteFe2 === void 0 ? void 0 : _data$friendsInviteFe2.assetsPackageId
              }));

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              !skipEventError((_error$error = _context.t0.error) === null || _error$error === void 0 ? void 0 : (_error$error$data = _error$error.data) === null || _error$error$data === void 0 ? void 0 : _error$error$data.errorType) && handleQueryLoggerEvents(_context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 12]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};